const getters = {
  GetWindowWidth: state => state.windowWidth,
  GetFeaturedInventory: state => state.featuredInventory,
  GetShowedConstruction: state => state.showedConstruction,
  GetMailPActive: state => state.mailPActive,
  GetEmailInventory: state => state.emailInventory,
  GetMJMLHTML: state => state.mjmlHTML,
}

export default getters
